import * as React from 'react';

export interface IT3IconProps {
  color?: string;
  size?: string | number;
  title?: string;
}

export const T3Icon = React.forwardRef<SVGSVGElement, IT3IconProps>(
  ({ color = 'currentColor', size = '1em', title = null, ...rest }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={size}
        height={size}
        fill={color}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <g xmlns="http://www.w3.org/2000/svg" transform="matrix(1.0404 0 0 1.0404 -98.016 -47.497)">
          <g fontFamily="sans-serif" fontSize="10.583px" wordSpacing="0px" aria-label="T 1">
            <g
              transform="matrix(.92985 0 0 .86537 6.8704 6.826)"
              fontFamily="sans-serif"
              fontSize="10.583px"
              aria-label="T1"
            >
              <g
                transform="matrix(3.0828,0,0,3.3126,-203.5,-95.579)"
                fontFamily="sans-serif"
                fontSize="8.652px"
                strokeWidth=".0072031"
                aria-label="T1"
              >
                <text x="97.087555" y="47.709003" fontFamily="sans-serif" fontSize="4.6513px" xmlSpace="preserve">
                  <tspan x="97.087555" y="47.709003" strokeWidth=".0072031" />
                </text>
                <g aria-label="T1">
                  <path d="m96.966 43.283q0-0.19967 0.19967-0.19967h1.9967q0.19967 0 0.19967 0.19967t-0.19967 0.19967h-0.79867v3.3943q0 0.19967-0.19967 0.19967t-0.19967-0.19967v-3.3943h-0.79867q-0.19967 0-0.19967-0.19967z" />
                  <g transform="scale(.97151 1.0293)" strokeWidth=".002486" aria-label="3">
                    <path
                      d="m103.64 43.823h-0.39508q-0.19754 0-0.19754-0.19754t0.19754-0.19754h0.39508q0.24842 0 0.41902-0.1706 0.1736-0.1736 0.1736-0.42202 0-0.24543-0.1736-0.41902-0.17359-0.1736-0.41902-0.1736h-0.79016q-0.19754 0-0.19754-0.19754t0.19754-0.19754h0.79016q0.41004 0 0.69737 0.29032 0.29033 0.29032 0.29033 0.69738 0 0.49086-0.39508 0.79016 0.39508 0.2993 0.39508 0.79016v0.39508q0 0.41004-0.29033 0.70037-0.29032 0.28733-0.69737 0.28733h-0.79016q-0.19754 0-0.19754-0.19754t0.19754-0.19754h0.79016q0.24842 0 0.41902-0.1706 0.1736-0.1736 0.1736-0.42202v-0.39508q0-0.24543-0.1736-0.41902-0.17359-0.1736-0.41902-0.1736z"
                      strokeWidth=".002486"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  },
);
